document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerToggle = document.getElementById('cart-drawer-toggle');
  const cartDrawerClose = document.getElementById('cart-drawer-close');
  const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');

  // Move drawer to body to escape any header stacking contexts
  if (cartDrawer && cartDrawer.parentNode !== document.body) {
    document.body.appendChild(cartDrawer);
  }

  // Close cart drawer
  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', function () {
      cartDrawer.classList.remove('active');
      cartDrawerToggle.setAttribute('aria-expanded', 'false');
    });
  }

  // Close on overlay click
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function () {
      cartDrawer.classList.remove('active');
      cartDrawerToggle.setAttribute('aria-expanded', 'false');
    });
  }

  // Load cart items via AJAX
  function loadCartItems() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderCartItems(cart);
        updateCartCount(cart.item_count);
      })
      .catch(error => console.error('Error loading cart:', error));
  }

  // Render cart items
  function renderCartItems(cart) {
    const cartItemsContainer = document.getElementById('cart-drawer-items');
    const cartEmptyMessage = document.getElementById('cart-empty-message');

    if (!cartItemsContainer) return;

    if (cart.items.length === 0) {
      cartItemsContainer.innerHTML = '<p class="cart-empty-message">Your cart is empty</p>';
      return;
    }

    if (cartEmptyMessage) cartEmptyMessage.style.display = 'none';
    let html = '';

    cart.items.forEach(item => {
      html += `
        <div class="cart-item" data-variant-id="${item.variant_id}">
          <div class="cart-item-image">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">` : '<div style="background:#f5f5f5;"></div>'}
          </div>
          <div class="cart-item-details">
            <h3 class="cart-item-title">${item.title}</h3>
            <div class="cart-item-price">${(item.price / 100).toFixed(2)} &euro; x ${item.quantity}</div>
            <div class="cart-item-quantity">
              <button onclick="updateCartQuantity('${item.key}', ${item.quantity - 1})">-</button>
              <span>${item.quantity}</span>
              <button onclick="updateCartQuantity('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <div class="cart-item-remove">
              <button onclick="removeFromCart('${item.key}')">Remove</button>
            </div>
          </div>
        </div>
      `;
    });

    cartItemsContainer.innerHTML = html;

    // Update subtotal
    const subtotal = (cart.total_price / 100).toFixed(2);
    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = subtotal + ' \u20ac';
  }

  // Update cart count in header
  function updateCartCount(count) {
    if (count === undefined || count === null) return;

    // Find all cart count displays (mobile + desktop might exist)
    const toggleBtns = document.querySelectorAll('#cart-drawer-toggle');

    toggleBtns.forEach(btn => {
      let badge = btn.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.id = 'cart-count-display';
          badge.textContent = count;
          btn.insertBefore(badge, btn.firstChild);
        } else {
          badge.textContent = count;
          badge.style.display = 'flex';
        }
      } else {
        if (badge) {
          badge.style.display = 'none';
        }
      }
    });
  }

  // Update quantity
  window.updateCartQuantity = function (variantId, newQuantity) {
    if (newQuantity <= 0) {
      removeFromCart(variantId);
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity
      })
    })
      .then(response => response.json())
      .then(cart => {
        loadCartItems();
        updateCartCount(cart.item_count);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(error => console.error('Error updating cart:', error));
  };

  // Remove from cart
  window.removeFromCart = function (variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
      .then(response => response.json())
      .then(cart => {
        loadCartItems();
        updateCartCount(cart.item_count);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(error => console.error('Error removing from cart:', error));
  };

  // Listen for add to cart events
  document.addEventListener('cart:add', function () {
    loadCartItems();
  });

  // Dynamic positioning of search overlay directly under navbar
  const navbarEl = document.querySelector('.navbar');
  const searchOverlayEl = document.querySelector('.search-bar-overlay');

  function updateSearchOverlayPosition() {
    if (navbarEl && searchOverlayEl) {
      const rect = navbarEl.getBoundingClientRect();
      const height = rect.height;
      searchOverlayEl.style.top = height + 'px';
      searchOverlayEl.style.height = `calc(100vh - ${height}px)`;
    }
  }

  const searchCloseArrowBtn = document.querySelector('.search-close-arrow-btn');

  // Trigger search position update when search bar opens
  document.querySelectorAll('.search-bar-open-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      setTimeout(() => {
        updateSearchOverlayPosition();
        if (searchResultsDropdown) searchResultsDropdown.style.display = 'none';
        if (searchInputField) searchInputField.value = '';
        if (searchClearBtn) searchClearBtn.style.display = 'none';
        if (searchCloseArrowBtn) {
          searchCloseArrowBtn.classList.remove('show-close');
          searchCloseArrowBtn.classList.add('show-up');
        }
      }, 50);
    });
  });

  window.addEventListener('resize', updateSearchOverlayPosition);

  // Close suggestions overlay when clicking close buttons
  if (searchCloseArrowBtn) {
    searchCloseArrowBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      const overlay = document.querySelector('.search-bar-overlay');
      const closeWindowBtn = document.querySelector('.search-bar-close-window-btn');
      if (overlay) {
        overlay.classList.remove('active');
        if (closeWindowBtn) closeWindowBtn.classList.remove('active');
        document.body.classList.remove('active');
        if(document.querySelector('.navbar')) document.querySelector('.navbar').classList.remove('search-active');
      }
    });
  }

  const closeWindowBtn = document.querySelector('.search-bar-close-window-btn');
  if (closeWindowBtn) {
    closeWindowBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      const overlay = document.querySelector('.search-bar-overlay');
      if (overlay) {
        overlay.classList.remove('active');
        closeWindowBtn.classList.remove('active');
        document.body.classList.remove('active');
        if(document.querySelector('.navbar')) document.querySelector('.navbar').classList.remove('search-active');
      }
    });
  }

  // Close when clicking outside the search bar
  document.addEventListener('click', function (e) {
    const overlay = document.querySelector('.search-bar-overlay');
    const searchBarInner = document.querySelector('.search-bar-inner');
    const closeWindowBtn = document.querySelector('.search-bar-close-window-btn');
    
    if (overlay && overlay.classList.contains('active')) {
      if (searchBarInner && !searchBarInner.contains(e.target) && !e.target.closest('.search-bar-open-btn')) {
        overlay.classList.remove('active');
        if (closeWindowBtn) closeWindowBtn.classList.remove('active');
        document.body.classList.remove('active');
        if(document.querySelector('.navbar')) document.querySelector('.navbar').classList.remove('search-active');
      }
    }
  });

  // Predictive Search functionality
  const searchInputField = document.getElementById('search-input-field');
  const searchClearBtn = document.querySelector('.search-clear-btn');
  const searchResultsDropdown = document.querySelector('.search-results-dropdown');
  const recommendationsWrapper = document.querySelector('.search-recommendations-wrapper');
  const dynamicWrapper = document.querySelector('.search-results-dynamic-wrapper');

  const searchSectionProducts = document.getElementById('search-section-products');
  const searchSectionArticles = document.getElementById('search-section-articles');
  const searchSectionPages = document.getElementById('search-section-pages');
  const searchResultsEmpty = document.querySelector('.search-results-empty');

  const productsGrid = document.querySelector('.products-grid');
  const articlesGrid = document.querySelector('.articles-grid');
  const pagesGrid = document.querySelector('.pages-grid');

  let debounceTimer;

  // Toggle dynamic results & recommendations
  function showRecommendations() {
    if (searchResultsDropdown) searchResultsDropdown.style.display = 'block';
    if (recommendationsWrapper) recommendationsWrapper.style.display = 'block';
    if (dynamicWrapper) dynamicWrapper.style.display = 'none';
    if (searchCloseArrowBtn) {
      searchCloseArrowBtn.classList.remove('show-up');
      searchCloseArrowBtn.classList.add('show-close');
    }
  }

  function showDynamicResults() {
    if (searchResultsDropdown) searchResultsDropdown.style.display = 'block';
    if (recommendationsWrapper) recommendationsWrapper.style.display = 'none';
    if (dynamicWrapper) dynamicWrapper.style.display = 'block';
    if (searchCloseArrowBtn) {
      searchCloseArrowBtn.classList.remove('show-up');
      searchCloseArrowBtn.classList.add('show-close');
    }
  }

  // Event delegation to collapse/expand sections on mobile
  if (searchResultsDropdown) {
    searchResultsDropdown.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        const heading = e.target.closest('.search-results-heading');
        if (heading) {
          const section = heading.closest('.search-results-section');
          if (section) {
            section.classList.toggle('collapsed');
          }
        }
      }
    });
  }

  if (searchInputField) {
    searchInputField.addEventListener('focus', function (e) {
      const overlay = document.querySelector('.search-bar-overlay');
      if (overlay && overlay.classList.contains('active')) {
        let query = searchInputField.value.trim();
        if (query.length === 0) {
          showRecommendations();
        } else {
          showDynamicResults();
        }
      }
    });

    searchInputField.addEventListener('click', function (e) {
      e.stopPropagation();
      let query = searchInputField.value.trim();
      if (query.length === 0) {
        showRecommendations();
      } else {
        showDynamicResults();
      }
    });

    searchInputField.addEventListener('input', function () {
      const query = searchInputField.value.trim();

      if (query.length > 0) {
        if (searchClearBtn) searchClearBtn.style.display = 'flex';
        showDynamicResults();
      } else {
        if (searchClearBtn) searchClearBtn.style.display = 'none';
        showRecommendations();
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (query.length > 0) {
          performPredictiveSearch(query);
        }
      }, 300);
    });

    if (searchClearBtn) {
      searchClearBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        searchInputField.value = '';
        searchClearBtn.style.display = 'none';
        if (searchResultsDropdown) searchResultsDropdown.style.display = 'none';
        if (searchCloseArrowBtn) {
          searchCloseArrowBtn.classList.remove('show-close');
          searchCloseArrowBtn.classList.add('show-up');
        }
      });
    }
  }

  function parsePredictivePrice(rawPrice) {
    if (rawPrice === null || rawPrice === undefined || rawPrice === '') return null;
    const cleaned = String(rawPrice).replace(',', '.').replace(/[^\d.]/g, '');
    const value = parseFloat(cleaned);
    if (!Number.isFinite(value)) return null;
    return value > 999 ? value / 100 : value;
  }

  function formatPredictivePrice(rawPrice) {
    const value = parsePredictivePrice(rawPrice);
    if (value === null) return '';
    return '\u20ac' + value.toFixed(2).replace('.', ',');
  }

  function performPredictiveSearch(query) {
    const limit = 6;
    // Standard Shopify predictive search endpoint with specific resources
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=${limit}&resources[options][fields]=title,body,tag`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        const results = data.resources.results;
        let hasResults = false;

        // 1. Process Products - Using full titles as requested
        if (results.products && results.products.length > 0) {
          hasResults = true;
          if (searchSectionProducts) searchSectionProducts.style.display = 'block';

          let productsHtml = '';
          results.products.forEach(product => {
            const formattedPrice = formatPredictivePrice(product.price);
            let badgeHtml = '';
            const compareAtPrice = parsePredictivePrice(product.compare_at_price);
            const currentPrice = parsePredictivePrice(product.price);
            if (compareAtPrice && currentPrice && compareAtPrice > currentPrice) {
              const discount = Math.round((compareAtPrice - currentPrice) / compareAtPrice * 100);
              if (discount > 0) {
                badgeHtml = `<div class="search-product-badge">-${discount}%</div>`;
              }
            }

            let category = product.type || product.vendor || 'Prodotto';
            if (product.tags && product.tags.length > 0) {
              const customCategoryTag = product.tags.find(t => 
                t.toLowerCase().includes('kit 1 day') || 
                t.toLowerCase().includes('kit 1 giorno') ||
                t.toLowerCase().includes('kit')
              );
              if (customCategoryTag) {
                category = customCategoryTag;
              }
            }

            productsHtml += `
              <a href="${product.url}" class="search-product-card">
                <div class="search-product-img-wrapper">
                  <img src="${product.image || '//cdn.shopify.com/s/files/1/0000/0000/assets/no-image.gif'}" alt="${product.title}" width="120" height="120" loading="lazy">
                </div>
                <div class="search-product-info">
                  <span class="search-product-category">${category}</span>
                  <h4 class="search-product-title">${product.title}</h4>
                  <span class="search-product-price-size">${formattedPrice}</span>
                </div>
                ${badgeHtml}
              </a>
            `;
          });
          if (productsGrid) productsGrid.innerHTML = productsHtml;
        } else {
          if (searchSectionProducts) searchSectionProducts.style.display = 'none';
          if (productsGrid) productsGrid.innerHTML = '';
        }

        // 2. Process Magazine (Articles)
        if (results.articles && results.articles.length > 0) {
          hasResults = true;
          if (searchSectionArticles) searchSectionArticles.style.display = 'block';

          let articlesHtml = '';
          results.articles.forEach(article => {
            const category = (article.tags && article.tags.length > 0) ? article.tags[0] : (article.blog || 'Magazine');
            articlesHtml += `
              <a href="${article.url}" class="search-article-card">
                <span class="search-article-category">${category}</span>
                <h4 class="search-article-title">${article.title}</h4>
              </a>
            `;
          });
          if (articlesGrid) articlesGrid.innerHTML = articlesHtml;
        } else {
          if (searchSectionArticles) searchSectionArticles.style.display = 'none';
          if (articlesGrid) articlesGrid.innerHTML = '';
        }

        // 3. Process Pagine (Pages)
        if (results.pages && results.pages.length > 0) {
          hasResults = true;
          if (searchSectionPages) searchSectionPages.style.display = 'block';

          let pagesHtml = '';
          results.pages.forEach(page => {
            pagesHtml += `
              <a href="${page.url}" class="search-page-card">
                <div class="search-page-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1450_15136)">
                      <path d="M4 13.3337V6.66699L10.6667 10.667V2.66699" stroke="#457634" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.66602 4.66699L10.666 2.66699L12.666 4.66699" stroke="#457634" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1450_15136">
                        <rect width="16" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h4 class="search-page-title">${page.title}</h4>
              </a>
            `;
          });
          if (pagesGrid) pagesGrid.innerHTML = pagesHtml;
        } else {
          if (searchSectionPages) searchSectionPages.style.display = 'none';
          if (pagesGrid) pagesGrid.innerHTML = '';
        }

        if (searchResultsDropdown) searchResultsDropdown.style.display = 'block';

        if (hasResults) {
          if (searchResultsEmpty) searchResultsEmpty.style.display = 'none';
        } else {
          if (searchResultsEmpty) searchResultsEmpty.style.display = 'block';
        }
      })
      .catch(error => {
        console.error('Error during predictive search:', error);
      });
  }
});

// Helper to update cart count when items are added
function updateHeaderCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === undefined) return;
      const toggleBtns = document.querySelectorAll('#cart-drawer-toggle');
      toggleBtns.forEach(btn => {
        let badge = btn.querySelector('.cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            badge.id = 'cart-count-display';
            badge.textContent = cart.item_count;
            btn.insertBefore(badge, btn.firstChild);
          } else {
            badge.textContent = cart.item_count;
            badge.style.display = 'flex';
          }
        } else if (badge) {
          badge.style.display = 'none';
        }
      });
    });
}
